import { render, staticRenderFns } from "./t-shop-card.vue?vue&type=template&id=6a85b7d1&scoped=true&"
import script from "./t-shop-card.vue?vue&type=script&lang=js&"
export * from "./t-shop-card.vue?vue&type=script&lang=js&"
import style0 from "@/css/Main_style.scss?vue&type=style&index=0&id=6a85b7d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85b7d1",
  null
  
)

export default component.exports